import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  title: ({ searchTerm }) => ({
    key: 'TerritoriesInSearchList-title',
    parameters: {
      searchTerm,
      strong: <strong />,
    },
    defaultValue: 'Tópicos que tenham vídeos com <strong>“{searchTerm}”</strong>',
  }),
})
